import { _validateEmail } from './../axios';

export const validateFields = async () => {

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(document.getElementById('contactFirstName').value === null || document.getElementById('contactFirstName').value === '') { return true; }

    if(document.getElementById('contactLastName').value === null || document.getElementById('contactLastName').value === '') { return true; }

    if(document.getElementById('contactEmailAddress').value === null || document.getElementById('contactEmailAddress').value === '') { return true; }

    const emailInput = document.getElementById('contactEmailAddress');
    if(!emailRegex.test(emailInput.value)) { return true; }

    const { data } = await _validateEmail(emailInput.value);
    if (!data.isAvailable) { return true; }

    if(document.getElementById('shippingPostalCode').value === null || document.getElementById('shippingPostalCode').value === '') { return true; }
    
    if(document.getElementById('shippingAddressLine1').value === null || document.getElementById('shippingAddressLine1').value === '') { return true; }

    if(document.getElementById('shippingCity').value === null || document.getElementById('shippingCity').value === '') { return true; }

    if(document.getElementById('shippingCountry').value === null || document.getElementById('shippingCountry').value === '') { return true; }

    if(document.getElementById('shippingState').value === null || document.getElementById('shippingState').value === '') { return true; }

    if(document.getElementById('billingPostalCode').value === null || document.getElementById('billingPostalCode').value === '') { return true; }
    
    if(document.getElementById('billingAddressLine1').value === null || document.getElementById('billingAddressLine1').value === '') { return true; }

    if(document.getElementById('billingCity').value === null || document.getElementById('billingCity').value === '') { return true; }

    if(document.getElementById('billingCountry').value === null || document.getElementById('billingCountry').value === '') { return true; }

    if(document.getElementById('billingState').value === null || document.getElementById('billingState').value === '') { return true; }

    if(document.getElementById('howManyTracker').value === null || document.getElementById('howManyTracker').value === '') {return true;}

    return false;
}